import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

const API_URL = process.env.API_URL

export default {
  query (params) {
    return Vue.http.get(`${API_URL}reminders`, {params: params})
  },
  get (id) {
    return Vue.http.get(`${API_URL}reminders/${id}`)
  },
  create (data) {
    return Vue.http.post(`${API_URL}reminders`, data)
  },
  update (id, data) {
    return Vue.http.patch(`${API_URL}reminders/${id}`, data)
  },
  delete (id) {
    return Vue.http.delete(`${API_URL}reminders/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/reminder.js